<template>
    <template-layout :breadCrumbList="breadcrumbComputed">
        <div class="py-12 px-4">
            <nav class="flex justify-between items-center mb-4">
                <div class="flex">
                    <h1 class="text-2xl text-theme-1">
                        รายงานการวิเคราะห์ข้อมูล PIVOT
                    </h1>
                    <button class="p-2 btn btn-outline-theme-36 rounded search-btn">
                        <MenuIcon @click="hideSearch" class="w-5 h-5" id="search_action"/>
                    </button>
                </div>
            </nav>
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 md:col-span-4 lg:col-span-3" id="search">
                    <PivotFilter />
                </div>
                <div class="col-span-12 md:col-span-8 lg:col-span-9" id="main_content">
                    <FilterSummary :items="filterSummaryStore" />
                    <PivotTable :filter="filterValue"/>
                </div>
            </div>
        </div>
    </template-layout>
</template>

<script setup>
import TemplateLayout from "@/layouts/side-menu/Main.vue"
import { computed, reactive } from "vue"
import PivotFilter from "@/components/filter-search/PivotTableFilter.vue";
import FilterSummary from "@/components/filter-summary/index.vue";
import { useStore } from "vuex";
import PivotTable from "./container/Pivot.vue"

const store = useStore();
const filterSummaryStore = computed(
  () => store.getters["pivotTableFilter/getFilterSummaryArray"]
);
const filterValue = computed(() => store.getters["pivotTableFilter/getFilterForApi"]);

const breadcrumbComputed = reactive([{
  name: "รายงานการวิเคราะห์ข้อมูล PIVOT",
  active: true
}])
const hideSearch = () => {

    const search_action = document.getElementById("search_action")
    search_action.classList.toggle("hide")
    const search = document.getElementById("search")
    const content = document.getElementById("main_content")
    if(search_action.classList.contains("hide")){
        // search_action.innerHTML = "แสดงการค้นหา"
        search.style.display="none"
        content.classList.remove("lg:col-span-9","md:col-span-8")
        content.classList.add("lg:col-span-12","md:col-span-12")
    }
    else{
        // search_action.innerHTML = "ซ่อนการค้นหา"
        search.style.display="block"
        content.classList.remove("lg:col-span-12","md:col-span-12")
        content.classList.add("lg:col-span-9","md:col-span-8")
    }

}
</script>
